// @flow
import React, { type Node } from 'react';

import PlainNav, { NavItem } from 'app/common/ui/PlainNav';

import { type Period } from './usePeriods';


type Props = {
  className?: string,
  periods: Array<Period>,
  additionalMenuItem: {
    title: string,
    link: string,
    current: boolean,
  }
}

const MenuLinePeriods = ({ className, periods, additionalMenuItem: ami }: Props): Node => {
  return (
    <PlainNav className={className}>
      {periods.map(({ title, link, current }) => (
        <NavItem key={title} to={link} active={!ami.current ? current : false}>
          {title}
        </NavItem>
      ))}
      <NavItem to={ami.link} active={ami.current}>
        {ami.title}
      </NavItem>
    </PlainNav>
  );
};

export default MenuLinePeriods;
